import { useApi } from '../composables'
import http from '../composables/src/useHttp'
import type { Company, CreateCompanyPayload, UpdateCompanyPayload } from '../types/organization'

export const getAllCompanies = (enriched?: boolean) => {
  const params = enriched === undefined ? undefined : { enriched: String(enriched) }

  return useApi<Company[]>(http.get('/companies', { params }))
}

export const getAllCompanyContacts = (id: string) => {
  return useApi(http.get(`/companies/${id}/members`))
}

export const setCompanyMember = (id: string, data: any) => {
  return useApi(
    http.post(`/companies/${id}/members`, {
      userIds: [data.id],
    }),
  )
}

export const deleteCompanies = (id: string) => {
  return useApi(http.delete(`/companies/${id}`))
}

export const createCompanies = (data: CreateCompanyPayload) => {
  return useApi<Company>(http.post('/companies', data))
}

export const updateCompanies = (id: string, data: UpdateCompanyPayload) => {
  return useApi<Company>(http.patch(`/companies/${id}`, data))
}

export const getCompanies = (id: string, enriched?: boolean) => {
  const params = enriched === undefined ? { enriched: 'true' } : { enriched: String(enriched) }

  return useApi<Company>(http.get(`/companies/${id}`, { params }))
}

export const checkCompanyDomainUnique = (domain: string) => {
  return useApi(http.get(`/companies/check-domain`, { params: { domain } }))
}

export const checkCompanyPrefixUnique = (prefix: string) => {
  return useApi(http.get(`/companies/check-prefix`, { params: { prefix } }))
}

export const getCompanyHistory = (id: string) => {
  return useApi(http.get(`/companies/${id}/history`))
}

export const saveTeamAllocation = (companyId: string, data: { allocations: any[]; users: any[] }) => {
  return useApi(http.post(`/companies/${companyId}/team-allocation`, data))
}

export const getTeamAllocation = (companyId: string) => {
  return useApi(http.get(`/companies/${companyId}/team-allocation`))
}
